import { cn } from '@@/lib/utils';

export enum WizardStep {
  TYPE = 1,
  MESSAGE = 2,
  SCHEDULE = 3,
  CONTACT_LIST = 4,
  REVIEW = 5
}

const WIZARD_STEPS: Array<{
  step: WizardStep;
  title: string;
  subtitle: string;
}> = [
  {
    step: WizardStep.TYPE,
    title: 'Type',
    subtitle: 'Select Campaign type'
  },
  {
    step: WizardStep.MESSAGE,
    title: 'Message',
    subtitle: 'Select Campaign Content'
  },
  {
    step: WizardStep.SCHEDULE,
    title: 'Schedule',
    subtitle: 'Select Campaign Duration'
  },
  {
    step: WizardStep.CONTACT_LIST,
    title: 'Contact List',
    subtitle: 'Select Campaign User list'
  },
  {
    step: WizardStep.REVIEW,
    title: 'Review',
    subtitle: 'Review & launch'
  }
];

export function WizardStepper(props: { currentStep: WizardStep }) {
  return (
    <div className='bg-card rounded-xl border border-border p-6 w-xs h-full'>
      <h2 className='text-lg font-semibold text-foreground mb-6'>New Campaign</h2>
      <div>
        {WIZARD_STEPS.map((stepConfig) => (
          <StepItem
            key={stepConfig.step}
            stepNumber={stepConfig.step}
            title={stepConfig.title}
            subtitle={stepConfig.subtitle}
            isActive={props.currentStep === stepConfig.step}
            isCompleted={props.currentStep > stepConfig.step}
          />
        ))}
      </div>
    </div>
  );
}

function StepItem(props: {
  stepNumber: number;
  title: string;
  subtitle: string;
  isActive: boolean;
  isCompleted: boolean;
}) {
  return (
    <div className='flex items-start gap-3'>
      <div className='flex flex-col items-center'>
        <div
          className={cn(
            'size-6 rounded-full border-2 flex items-center',
            'justify-center text-xs font-medium mt-1.5',
            props.isActive && 'border-blue bg-card',
            props.isCompleted && 'border-blue bg-blue text-white',
            !props.isActive && !props.isCompleted && 'border-border bg-card text-muted-foreground'
          )}
        >
          {props.isCompleted ? <CheckIcon /> : null}
        </div>
        {props.stepNumber < 5 && <div className={cn('w-0.5 h-6 mt-1', props.isCompleted ? 'bg-blue' : 'bg-border')} />}
      </div>
      <div className='flex-1 space-y-0.5'>
        <p className={cn('text-sm font-medium', props.isActive ? 'text-blue' : 'text-foreground')}>{props.title}</p>
        <p className={cn('text-xs', props.isActive ? 'text-blue' : 'text-muted-foreground')}>{props.subtitle}</p>
      </div>
    </div>
  );
}

function CheckIcon() {
  return (
    <svg className='w-3 h-3' fill='currentColor' viewBox='0 0 20 20'>
      <path
        fillRule='evenodd'
        d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414
          0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1
          1 0 011.414 0z'
        clipRule='evenodd'
      />
    </svg>
  );
}
